import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

type GroupsTabSearchBarProps = {
  value: string
  onChange: (value: string) => void
}

function GroupsTabSearchBar({ value, onChange }: Readonly<GroupsTabSearchBarProps>) {
  const { t } = useTranslation()

  return (
    <TextField
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton aria-label={t('common.clear')} edge="end" size="small" onClick={() => onChange('')}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      inputProps={{
        'aria-label': t('bidding.bidding_cascading.groups_tab.search.placeholder'),
      }}
      placeholder={t('bidding.bidding_cascading.groups_tab.search.placeholder')}
      size="small"
      sx={{ mb: 2 }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

export default GroupsTabSearchBar
